import React from 'react'
import { Container, useMediaQuery, Tabs, Tab } from '@material-ui/core'
import {
  useHistory,
  useLocation,
  useRouteMatch,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'
import FlexView from 'react-flexview/lib'
import { SessionContextStore } from '../../context/SessionContext'
import { UserProfile } from '../UserProfile/UserProfile'
import { CheckoutForm } from '../CreditCard/CheckoutForm'
import { isBrowser } from 'react-device-detect'
import { EmailAndPassword } from './EmailAndPassword'
import { SessionService } from '../../services/SessionService'
import { BlueGrayBox } from '../Core/BlueGrayBox'
import { RefferalRequests } from './ReferralRequests'

export const Account = () => {
  const sessionContext = React.useContext(SessionContextStore)
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))

  const location = useLocation()
  const history = useHistory()
  let { path, url } = useRouteMatch()

  const getTabIndex = () => {
    switch (location.pathname) {
      case '/account/profle':
        return 0
      case '/account/credit-card':
        return 1
      case '/account/change-login-information':
        return 2
      case '/account/refferal-admin-view':
        return SessionService.isAdmin() ? 3 : 0
      default:
        return 0
    }
  }

  const [tabIndex, setTabIndex] = React.useState(getTabIndex())

  const handleTabChange = (event, newValue) => {
    switch (newValue) {
      case 0:
        history.replace(`${path}/profile`)
        break
      case 1:
        history.replace(`${path}/credit-card`)
        break
      case 2:
        history.replace(`${path}/change-login-information`)
        break
      case 3:
        history.replace(`${path}/refferal-admin-view`)
        break
      default:
        break
    }

    setTabIndex(newValue)
  }

  return (
    <Container maxWidth="lg" className="margin-top-basic">
      <FlexView hAlignContent={'center'} column={isMobile}>
        {isMobile && (
          <div className="text-title textcenter black bold margin-top-basic">
            Your Account
          </div>
        )}
        <Tabs
          orientation={isMobile ? 'horizontal' : 'vertical'}
          variant="scrollable"
          value={tabIndex}
          indicatorColor={'primary'}
          textColor="primary"
          onChange={handleTabChange}>
          <Tab label="Profile Details" />
          <Tab label="Payment Details" />
          <Tab label="Change Email" />
          {SessionService.isAdmin() && <Tab label="Referral Requests" />}
        </Tabs>
        <div className="full-width margin-left-basic margin-right-basic">
          {!isMobile && (
            <FlexView vAlignContent={'bottom'}>
              <div className="text-title black bold margin-top-basic">
                Your Account
              </div>
              {SessionService.isBroker() && (
                <div className="margin-top-basic text-tiny margin-left-6">
                  <BlueGrayBox>{sessionContext.user.email}</BlueGrayBox>
                </div>
              )}
            </FlexView>
          )}
          <Switch>
            <Route exact path={`${path}/profile`}>
              <UserProfile />
            </Route>
            <Route exact path={`${path}/credit-card`}>
              <CheckoutForm />
            </Route>
            <Route exact path={`${path}/change-login-information`}>
              <EmailAndPassword />
            </Route>
            <Route exact path={`${path}/refferal-admin-view`}>
              <RefferalRequests />
            </Route>
            <Redirect from={`${url}`} to={`${url}/profile`} />
          </Switch>
        </div>
      </FlexView>
    </Container>
  )
}
